import React, { FC, useMemo } from "react";
import { FormQuestionDto } from "@green0meter/api-client";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { MenuItem, Select, Typography } from "@components/base";

interface RelevantYear {
  question: FormQuestionDto;
}

const RelevantYear: FC<RelevantYear> = ({ question }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const options = useMemo(() => {
    const year = new Date().getFullYear() - 5;

    return Array.from({ length: 5 }, (_, i) => (
      <MenuItem value={year + i} key={`${question.questionId}-${year + i}`}>
        {year + i}
      </MenuItem>
    ));
  }, [question]);

  return (
    <Controller
      control={control}
      name={`${question.code}-relevantYear`}
      render={({ field }) => (
        <Select
          variant="filled"
          displayEmpty
          {...field}
          value={field.value ?? "none"}
          fullWidth
        >
          <MenuItem value={"none"} disabled>
            <Typography color="textSecondary" fontStyle="italic">
              {t("multistep.relevantYear.selectYear")}
            </Typography>
          </MenuItem>
          {options}
        </Select>
      )}
    />
  );
};

export default RelevantYear;
